import { render, staticRenderFns } from "./AppEdit.vue?vue&type=template&id=9885ee26&scoped=true&"
import script from "./AppEdit.vue?vue&type=script&lang=js&"
export * from "./AppEdit.vue?vue&type=script&lang=js&"
import style0 from "./AppEdit.vue?vue&type=style&index=0&id=9885ee26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9885ee26",
  null
  
)

export default component.exports